import { useCallback, useState } from 'react';

export default function useDesktopNavbarManager() {
  const [currentBlade, setBlade] = useState('');
  const resetActiveBlade = useCallback(() => setBlade(''), []);

  const toggleBlade = useCallback(
    (value, event) => {
      event.preventDefault();

      if (currentBlade === value) {
        setBlade('');
      } else {
        setBlade(value);
      }
    },
    [currentBlade]
  );

  return {
    resetActiveBlade,
    toggleBlade,
    currentBlade,
  };
}
